import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import Inicio from './components/Inicio'
import Diretoria from './components/Diretoria'
import ConvencoesColetivas from './components/ConvencoesColetivas'
import Beneficios from './components/Beneficios'
import Noticias from './components/Noticias'
import Juridico from './components/Juridico'
import Jornal from './components/Jornal'
import Associe from './components/Associe'
import Contato from './components/Contato'
import NoticiasConteudo from './components/NoticiasConteudo'

import PageRendererService from './services/PageRendererService'
import MainLayout from './components/MainLayout'
import Loading from './components/Loading'

function App() {

  const [website, setWebsite] = useState(undefined)

  useEffect(() => {
    // AnalyticsService.initialize();
    const fetchData = async () => {
      const websiteId = parseInt(process.env.REACT_APP_WEBSITE_ID, 10)
      // const result = await ApiService.getStructure(websiteId)
      const result = {
        "id": 5,
        "name": "Sindicato dos Metalurgicos",
        "domain": "metalurgicosbauru.com.br",
        "pages": [
          {
            "path": "/",
            "components": [
              {
                "elements": {
                  "line": 1,
                  "content": {
                    "1": {
                      "content": <Inicio />,
                    }
                  }
                }
              }
            ]
          },
          {
            "path": "/diretoria",
            "components": [
              {
                "elements": {
                  "line": 1,
                  "content": {
                    "1": {
                      "content": <Diretoria />,
                    }
                  }
                }
              }
            ]
          },
          {
            "path": "/convencoes-coletivas",
            "components": [
              {
                "elements": {
                  "line": 1,
                  "content": {
                    "1": {
                      "content": <ConvencoesColetivas />,
                    }
                  }
                }
              }
            ]
          },
          {
            "path": "/beneficios",
            "components": [
              {
                "elements": {
                  "line": 1,
                  "content": {
                    "1": {
                      "content": <Beneficios />,
                    }
                  }
                }
              }
            ]
          },
          {
            "path": "/noticias",
            "components": [
              {
                "elements": {
                  "line": 1,
                  "content": {
                    "1": {
                      "content": <Noticias />,
                    }
                  }
                }
              }
            ]
          },
          {
            "path": "/juridico",
            "components": [
              {
                "elements": {
                  "line": 1,
                  "content": {
                    "1": {
                      "content": <Juridico />,
                    }
                  }
                }
              }
            ]
          },
          {
            "path": "/jornal",
            "components": [
              {
                "elements": {
                  "line": 1,
                  "content": {
                    "1": {
                      "content": <Jornal />,
                    }
                  }
                }
              }
            ]
          },
          {
            "path": "/associe-se",
            "components": [
              {
                "elements": {
                  "line": 1,
                  "content": {
                    "1": {
                      "content": <Associe />,
                    }
                  }
                }
              }
            ]
          },
          {
            "path": "/contato",
            "components": [
              {
                "elements": {
                  "line": 1,
                  "content": {
                    "1": {
                      "content": <Contato />,
                    }
                  }
                }
              }
            ]
          },
          {
            "path": "/noticias/:slug",
            "components": [
              {
                "elements": {
                  "line": 1,
                  "content": {
                    "1": {
                      "content": <NoticiasConteudo />,
                    }
                  }
                }
              }
            ]
          },
        ]
      }
      setWebsite(result)
    }
    fetchData()
  }, [])

  if (website === undefined) {
    return <Loading />
  }
  
  return (
    <Router>
      <Routes>
        <Route element={<MainLayout />}>
          {website.pages.map((page) => (
            <Route key={page.path} path={page.path} element={<PageRendererService page={page} />} />
          ))}
        </Route>
      </Routes>
    </Router>
  )
}

export default App